import createIcon from '../../createIcon';

/**
 * @component @name Gite
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNi41SDlWNC41SDdWNi41SDZMMiAxMC41VjE5LjVIMjJWMTAuNUwxOCA2LjVaTTQgMTIuNUgxNFYxNy41SDRWMTIuNVpNMjAgMTcuNUgxNlYxMS4zM0wxOCA5LjMzTDIwIDExLjMzVjE3LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Gite = createIcon('Gite', [
  [
    'path',
    {
      d: 'M18 6.5H9V4.5H7V6.5H6L2 10.5V19.5H22V10.5L18 6.5ZM4 12.5H14V17.5H4V12.5ZM20 17.5H16V11.33L18 9.33L20 11.33V17.5Z',
      key: 'sdynj5',
    },
  ],
]);

export default Gite;
